// @ts-nocheck
import React, { useState } from 'react';
import EyeIcon from '../components/EyeIcon';
import { useNavigate } from 'react-router-dom';
import { changePassword } from '../services/api';
import { useAuth } from '../context/AuthContext';
import PrivacyNoticeLink from '../components/PrivacyNoticeLink';

export default function ChangePassword() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState<any>('');
  const [newPassword, setNewPassword] = useState<any>('');
  const [confirmPassword, setConfirmPassword] = useState<any>('');
  const [showCurrent, setShowCurrent] = useState<any>(false);
  const [showNew, setShowNew] = useState<any>(false);
  const [showConfirm, setShowConfirm] = useState<any>(false);
  const [error, setError] = useState<any>('');
  const [success, setSuccess] = useState<any>('');
  const [loading, setLoading] = useState<any>(false);

  // Determine if this is a forced first-login change
  // (no current password needed for forced changes — backend handles it)
  const isForced = user?.must_change_password !== false;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (newPassword.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await changePassword(isForced ? '' : currentPassword, newPassword);
      setSuccess('Password updated! Redirecting…');
      setTimeout(() => {
        const role = user?.role || user?.roles?.[0];
        if (user?.onboarding_required) navigate('/admin/onboarding');
        else if (role === 'developer') navigate('/developer/home');
        else if (role === 'superadmin') navigate('/superadmin/home');
        else if (role === 'admin' || role === 'school_admin' || role === 'district_admin') navigate('/admin');
        else if (role === 'teacher' || role === 'special_services_teacher') navigate('/teacher/home');
        else if (role === 'student') navigate('/student/home');
        else if (role === 'parent' || role === 'family') navigate('/parent/home');
        else navigate('/dashboard');
      }, 1200);
    } catch (err: any) {
      setError(err.message || 'Password change failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(180deg, #f8fbff 0%, #f2f6fc 100%)',
    }}>
      <div style={{
        background: 'var(--ae-surface)',
        borderRadius: 16,
        padding: '2.5rem 2rem',
        width: '100%',
        maxWidth: 420,
        boxShadow: 'var(--ae-shadow-soft)',
        border: '1px solid var(--ae-border)',
        borderTop: '5px solid var(--ae-primary)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>🔒</div>
          <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: 'var(--ae-primary-strong)' }}>
            {isForced ? 'Set Your Password' : 'Change Password'}
          </h2>
          {isForced && (
            <p style={{ margin: '8px 0 0', fontSize: 14, color: 'var(--ae-text-muted)' }}>
              Your account requires a new password before you can continue.
            </p>
          )}
        </div>


        <form onSubmit={handleSubmit}>
          {!isForced && (
            <div style={{ marginBottom: 16, position: 'relative', display: 'flex', alignItems: 'center' }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 4 }}>
                Current Password
              </label>
              <input
                type={showCurrent ? 'text' : 'password'}
                value={currentPassword}
                onChange={e => setCurrentPassword(e.target.value)}
                required
                style={{ ...inputStyle, width: '100%', margin: 0, paddingRight: 38 }}
                placeholder="Enter current password"
              />
              <button
                type="button"
                onClick={() => setShowCurrent(v => !v)}
                style={{
                  position: 'absolute',
                  right: 10,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: 0,
                  lineHeight: 1,
                }}
                tabIndex={-1}
                aria-label={showCurrent ? 'Hide password' : 'Show password'}
              >
                <EyeIcon open={showCurrent} style={{ opacity: 0.85 }} />
              </button>
            </div>
          )}

          <div style={{ marginBottom: 16, position: 'relative', display: 'flex', alignItems: 'center' }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 4 }}>
              New Password
            </label>
            <input
              type={showNew ? 'text' : 'password'}
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              required
              minLength={8}
              style={{ ...inputStyle, width: '100%', margin: 0, paddingRight: 38 }}
              placeholder="At least 8 characters"
            />
            <button
              type="button"
              onClick={() => setShowNew(v => !v)}
              style={{
                position: 'absolute',
                right: 10,
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: 0,
                lineHeight: 1,
              }}
              tabIndex={-1}
              aria-label={showNew ? 'Hide password' : 'Show password'}
            >
              <EyeIcon open={showNew} style={{ opacity: 0.85 }} />
            </button>
          </div>

          <div style={{ marginBottom: 24, position: 'relative', display: 'flex', alignItems: 'center' }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 4 }}>
              Confirm New Password
            </label>
            <input
              type={showConfirm ? 'text' : 'password'}
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              required
              style={{ ...inputStyle, width: '100%', margin: 0, paddingRight: 38 }}
              placeholder="Re-enter new password"
            />
            <button
              type="button"
              onClick={() => setShowConfirm(v => !v)}
              style={{
                position: 'absolute',
                right: 10,
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: 0,
                lineHeight: 1,
              }}
              tabIndex={-1}
              aria-label={showConfirm ? 'Hide password' : 'Show password'}
            >
              <EyeIcon open={showConfirm} style={{ opacity: 0.85 }} />
            </button>
          </div>

          {error && (
            <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 6, padding: '8px 12px', marginBottom: 16, color: '#dc2626', fontSize: 14 }}>
              {error}
            </div>
          )}
          {success && (
            <div style={{ background: '#f0fdf4', border: '1px solid #86efac', borderRadius: 6, padding: '8px 12px', marginBottom: 16, color: '#16a34a', fontSize: 14 }}>
              {success}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '10px 0',
              background: loading ? '#99b8ea' : 'linear-gradient(135deg, var(--ae-primary) 0%, #2f66c9 100%)',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              fontWeight: 700,
              fontSize: 15,
              cursor: loading ? 'not-allowed' : 'pointer',
            }}
          >
            {loading ? 'Saving…' : 'Set Password'}
          </button>
        </form>
        <div style={{ marginTop: 16, textAlign: 'center' }}><PrivacyNoticeLink /></div>
      </div>
    </div>
  );
}

const inputStyle = {
  width: '100%',
  padding: '9px 12px',
  border: '1px solid #d1d5db',
  borderRadius: 7,
  fontSize: 14,
  outline: 'none',
  boxSizing: 'border-box',
};
